import ajax from './ajax'
// const BASE_URL = 'http://192.168.31.162:7700'
const BASE_URL = '/api';
const POST_RES = 'POST';
const GET_RES = 'GET';
const PUT_RES = 'PUT';
const DELETE_RES = 'DELETE';

/* 登录信息 */
// 接收登录数据
export const reqLogin = (userName,password,verifyCode) => ajax(BASE_URL+'/system/login',{userName,password,verifyCode},POST_RES);
// 获取图片验证码
export const getVerifiCode = (options) => { return ( BASE_URL + "/system/getVerifyCode"); }

// 退出登录
export const reqLoginOut = () => ajax(BASE_URL+'/logout',{},POST_RES);
// 左侧菜单列表
export const reqMenuList = () => ajax(BASE_URL + "/system/sys/menu/getLeftMenus?parentId=8811", {},GET_RES);

/* 企业信息 */
// 获取登录用户的企业信息
export const reqEnterprise = () => ajax(BASE_URL + "/trace/enterprise/getEnterpriseInfo",{},GET_RES);
// export const reqUpdateEnterprise = (data) =>ajax (BASE_URL + "/trace/enterprise/update", {data},POST_RES);


/* 基地信息 */
// 基地信息列表数据
export const reqBase = (currentPage,rowCount,name) => ajax(BASE_URL + "/trace/base/query",{currentPage,rowCount,name},GET_RES);
// 新增基地信息
// export const reqAddBase = () => ajax(BASE_URL + "/trace/manufacture/add", {},);

/* 生产信息 */
// 生产信息列表数据
export const reqProduction = (currentPage,rowCount,name,status) => ajax(BASE_URL + "/trace/production/query",{currentPage,rowCount,name,status},GET_RES);

/* 加工信息 */
// 加工信息列表数据
export const reqManufacture =  (currentPage,rowCount,name,status) => ajax(BASE_URL + "/trace/manufacture/query",{currentPage,rowCount,name,status},GET_RES);

/* 追溯码信息 */
// 追溯码信息列表数据
// export const reqCode = (currentPage,rowCount,name) =>ajax(BASE_URL + "/trace/code/query",{currentPage,rowCount,name},GET_RES);










// WEBPACK FOOTER //
// ./src/api/index.js